// SCORM 1.2 error codes
const ERROR_CODE = {
  0: 'No error.',
  101: 'General Exception.',
  201: 'Invalid argument error.',
  202: 'Element cannot have children.',
  203: 'Element not an array. Cannot have count.',
  301: 'Not initialized.',
  401: 'Not implemented error',
  402: 'Invalid set value, element is a keyword',
  403: 'Element is read only.',
  404: 'Element is write only.',
  405: 'Incorrect Data Type.',
};

export default class Scorm12 {
  // initialized = false;
  // apiLastError = '0';

  // data = {};

  constructor(initialValues = {}) {
    this.initialized = false;
    this.apiLastError = '0';
    this.data = {...initialValues};
  }

  /**
   * This function indicates to the API Adapter that the SCO is going to communicate
   * with the LMS. It allows the LMS to handle LMS specific initialization issues.
   * It is a requirement of the SCO that it call this function before calling any
   * other API functions.
   *
   * If a return LMS is in processed "true" result indicates that the LMSInitialize("")
   * was successful. "false" result indicates that the LMSInitialize("") was unsuccessful
   * value of "false" is returned, then this signifies to the SCO that the an unknown
   * state and that any additional API calls will not be by the LMS.
   *
   * LMSInitialize(parameter)
   *
   * @param emptyString
   * An empty string must be passed for conformance to this standard.
   * Values other than "" are reserved for future extensions.
   *
   * @returns result
   * String representing a boolean.
   */
  LMSInitialize(emptyString) {
    if (emptyString !== '') {
      console.error(
        'LMSInitialize called without an empty string but: ',
        emptyString
      );
      return 'false';
    }

    console.log('[SCORM|LMSInitialize]', this.initialized);

    // if (this.initialized) {
    //   this.apiLastError = 101;
    //   return 'false';
    // }

    this.initialized = true;

    this.apiLastError = '0';
    return 'true';
  }

  LMSCommit(emptyString) {
    if (emptyString !== '') {
      console.error(
        'LMSCommit called without an empty string but: ',
        emptyString
      );
      return 'false';
    }

    console.log('[SCORM|LMSCommit]', this.initialized, this.data);

    if (!this.initialized) {
      this.apiLastError = '301';
      // throw new Error(`API is not initialized calling LMSCommit`);
      return 'false';
    }

    this.apiLastError = '0';
    return 'true';
  }

  LMSFinish(emptyString) {
    if (emptyString !== '') {
      console.error(
        'LMSFinish called without an empty string but: ',
        emptyString
      );
      return 'false';
    }

    console.log('[SCORM|LMSFinish]', this.initialized);

    if (!this.initialized) {
      this.apiLastError = '301';
      return 'false';
    }

    this.initialized = false;

    this.apiLastError = '0';
    return 'true';
  }

  LMSGetValue(param) {
    if (!this.initialized) {
      this.apiLastError = '301';
      return '';
    }

    const value = this.data[param];

    console.log('[SCORM|LMSGetValue]', this.initialized, param, value);

    if (value === undefined) {
      this.apiLastError = '201';
      return '';
    }

    this.apiLastError = '0';
    return value;
  }

  LMSSetValue(param, value) {
    if (!this.initialized) {
      this.apiLastError = '301';
      return 'false';
    }

    console.log('[SCORM|LMSSetValue]', this.initialized, param, value);

    this.data[param] = value;

    this.apiLastError = '0';
    return 'true';
  }

  LMSGetLastError() {
    return this.apiLastError;
  }
  LMSGetErrorString() {
    return '';
  }

  LMSGetDiagnostic() {
    return '';
  }
}
